import React from 'react';

const Context = React.createContext({
    modal: undefined,
    showModal: (title, content, position, size) => {},
    closeModal: () => {},
});

export default Context;
